import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {Router, Event, NavigationEnd} from '@angular/router';
import { AuthService } from '@services/auth.service';
import { VersionCheckService } from '@services/version-check.service';
import {environment} from 'environments/environment';
import {GoogleAnalyticsService} from 'ngx-google-analytics';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit,OnDestroy  {
    sessionInterval: any;
    constructor(
        private router: Router,
        protected $gaService: GoogleAnalyticsService,
         private versionService: VersionCheckService,private authService: AuthService
    ) {
        this.router.events.subscribe((event: Event) => {
            if (
                event instanceof NavigationEnd &&
                environment.NODE_ENV === 'production'
            ) {
                this.$gaService.pageView(event.url);
            }
        });
    }

    ngOnInit(): void {

    this.authService.checkSessionExpiry();
    this.sessionInterval = setInterval(() => {

      this.authService.checkSessionExpiry();

    }, 60000);

    this.versionService.checkVersion();

    setInterval(() => {

      this.versionService.checkVersion();

    }, 600000);

  }

  @HostListener('window:focus')
  onFocus(): void {

    this.versionService.checkVersion();

  }

  ngOnDestroy(): void {

    if (this.sessionInterval) {

      clearInterval(this.sessionInterval);
    }
  }

    
}
